import React, { useState } from "react";
import "./Register.css";
import { useNavigate } from "react-router-dom";

function Register() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [customGender, setCustomGender] = useState("");
  const [country, setCountry] = useState("");
  const [experience, setExperience] = useState("");
  const [roleTitle, setRoleTitle] = useState("");
  const [roleResponsibilities, setRoleResponsibilities] = useState("");
  const [methodologies, setMethodologies] = useState([]);
  const [otherMethodology, setOtherMethodology] = useState("");
  const [primaryDomain, setPrimaryDomain] = useState([]);
  const [otherPrimaryDomain, setOtherPrimaryDomain] = useState("");
  const [organizationType, setOrganizationType] = useState("");
  const [teamSize, setTeamSize] = useState("");
  const [personalAffinity, setPersonalAffinity] = useState("");
  const [teamAffinity, setTeamAffinity] = useState("");

  const handleCheckboxChange = (event, setter, values) => {
    const { value, checked } = event.target;
    if (checked) {
      setter([...values, value]);
    } else {
      setter(values.filter((item) => item !== value));
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/register`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          email,
          password,
          confirm_password: confirmPassword,
          age,
          gender: gender === "Other" ? customGender : gender,
          country,
          experience,
          roleTitle,
          roleResponsibilities,
          methodologies,
          primaryDomain,
          organizationType,
          teamSize,
          personalAffinity,
          teamAffinity,
        }),
      }
    );

    const data = await response.json();
    if (response.ok) {
      navigate(`/Dashboard`);
    } else {
      alert(data.error);
    }
  };

  return (
    <div className="register-container">
      <header className="register-header">
        <button onClick={() => navigate(`/`)}>Return to Login</button>
      </header>
      <div className="register-title">
        <h1>Sign up as an Empathy Tool user</h1>
      </div>

      <div className="register-body">
        <form onSubmit={handleRegister}>
          <div>
            <label>Username:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Confirm Password:</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          {/* Age Question */}
          <div>
            <label>How old are you?</label>
            <select
              value={age}
              onChange={(e) => setAge(e.target.value)}
              required
            >
              <option value="">Select one</option>
              <option value="Below 20">Below 20</option>
              <option value="21-30">21-30</option>
              <option value="31-40">31-40</option>
              <option value="41-50">41-50</option>
              <option value="51-60">51-60</option>
              <option value="61-70">61-70</option>
              <option value="Above 70">Above 70</option>
              <option value="Prefer not to answer">Prefer not to answer</option>
            </select>
          </div>

          {/* Gender Question */}
          <div>
            <label>How do you identify your gender?</label>
            <select
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              required
            >
              <option value="">Select one</option>
              <option value="Woman">Woman</option>
              <option value="Man">Man</option>
              <option value="Non-binary / gender diverse">
                Non-binary / gender diverse
              </option>
              <option value="Other">My gender identity isn't listed</option>
              <option value="Prefer not to answer">Prefer not to answer</option>
            </select>
            {gender === "Other" && (
              <input
                type="text"
                placeholder="Specify your gender"
                value={customGender}
                onChange={(e) => setCustomGender(e.target.value)}
              />
            )}
          </div>

          {/* Country Question */}
          <div>
            <label>What is your country of residence?</label>
            <input
              type="text"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              required
            />
          </div>

          {/* Experience Question */}
          <div>
            <label>
              How many years of experience do you have as a software
              practitioner?
            </label>
            <select
              value={experience}
              onChange={(e) => setExperience(e.target.value)}
              required
            >
              <option value="">Select one</option>
              <option value="No Experience">No Experience</option>
              <option value="Less than 3 years">Less than 3 years</option>
              <option value="3-5 years">Between 3-5 years</option>
              <option value="5-10 years">Between 5-10 years</option>
              <option value="10-15 years">Between 10-15 years</option>
              <option value="15-20 years">Between 15-20 years</option>
              <option value="20-30 years">Between 20-30 years</option>
              <option value="30-40 years">Between 30-40 years</option>
              <option value="40-50 years">Between 40-50 years</option>
              <option value="More than 50 years">More than 50 years</option>
            </select>
          </div>

          {/* Role Title */}
          <div>
            <label>What is the title/designation of your role?</label>
            <select
              id="roleTitle"
              value={roleTitle}
              onChange={(e) => setRoleTitle(e.target.value)}
              required
            >
              <option value="">Select one</option>
              <option value="Software Developer">Software Developer</option>
              <option value="Tester">Tester</option>
              <option value="Software Architect">Software Architect</option>
              <option value="Product Manager">Product Manager</option>
              <option value="Business Analyst">Business Analyst</option>
              <option value="Product Owner">Product Owner</option>
              <option value="UI/UX">UI/UX</option>
              <option value="DevOps Engineer">DevOps Engineer</option>
              <option value="Practitioner">Practitioner</option>
            </select>
          </div>

          {/* Responsibilities */}
          <div>
            <label>What are the main responsibilities of your role?</label>
            <input
              type="text"
              value={roleResponsibilities}
              onChange={(e) => setRoleResponsibilities(e.target.value)}
              required
            />
          </div>
          {/* Methodologies */}
          <div className="full-width">
            <label>
              What types of software development methodologies have you
              primarily been involved in?
            </label>
            <div className="checkbox-group">
              {[
                "Traditional (Waterfall)",
                "Agile - Kanban",
                "Agile - Scrum",
                "Agile - XP",
              ].map((method) => (
                <label key={method}>
                  <input
                    type="checkbox"
                    value={method}
                    onChange={(e) =>
                      handleCheckboxChange(e, setMethodologies, methodologies)
                    }
                  />
                  {method}
                </label>
              ))}
            </div>
            <input
              type="text"
              className="other-input"
              placeholder="Other (Please specify)"
              value={otherMethodology}
              onChange={(e) => setOtherMethodology(e.target.value)}
            />
          </div>

          {/* Primary Domain */}
          <div className="full-width">
            <label>
              What is the primary domain you have been involved in your current
              role?
            </label>
            <div className="checkbox-group">
              {[
                "Telecommunication",
                "Healthcare",
                "Sales and Manufacturing",
                "Finance",
              ].map((domain) => (
                <label key={domain}>
                  <input
                    type="checkbox"
                    value={domain}
                    onChange={(e) =>
                      handleCheckboxChange(e, setPrimaryDomain, primaryDomain)
                    }
                  />
                  {domain}
                </label>
              ))}
            </div>
            <input
              type="text"
              className="other-input"
              placeholder="Other (Please specify)"
              value={otherPrimaryDomain}
              onChange={(e) => setOtherPrimaryDomain(e.target.value)}
            />
          </div>

          {/* Organization Type */}
          <div className="full-width">
            <label>
              What is the nature of the organization you are affiliated with?
            </label>
            <select
              value={organizationType}
              onChange={(e) => setOrganizationType(e.target.value)}
              required
            >
              <option value="">Select one</option>
              <option value="SE Student">SE Student</option>
              <option value="Self-Employed">Self-Employed</option>
              <option value="Startup (5-10 employees)">
                Startup (5-10 employees)
              </option>
              <option value="Small (10-100 employees)">
                Small (10-100 employees)
              </option>
              <option value="Medium (100-500 employees)">
                Medium (100-500 employees)
              </option>
              <option value="Large (More than 500 employees)">
                Large (More than 500 employees)
              </option>
            </select>
          </div>

          {/* Team Size */}
          <div className="full-width">
            <label>How many team members are part of your current team?</label>
            <select
              value={teamSize}
              onChange={(e) => setTeamSize(e.target.value)}
              required
            >
              <option value="">Select one</option>
              <option value="No members">No members</option>
              <option value="Less than or equal to 5">
                Less than or equal to 5
              </option>
              <option value="5-10">5-10</option>
              <option value="10-20">10-20</option>
              <option value="More than 20">More than 20</option>
            </select>
          </div>

          {/* Personal Affinity */}
          <div className="full-width">
            <label>
              How would you rate your affinity to technology versus people?
            </label>
            <select
              value={personalAffinity}
              onChange={(e) => setPersonalAffinity(e.target.value)}
              required
            >
              <option value="">Select one</option>
              <option value="Predominantly Human-Centred">
                Predominantly Human-Centred
              </option>
              <option value="Somewhat Human-Centred">
                Somewhat Human-Centred
              </option>
              <option value="Somewhat Technology-Centric">
                Somewhat Technology-Centric
              </option>
              <option value="Predominantly Technology Centric">
                Predominantly Technology Centric
              </option>
            </select>
          </div>

          {/* Team Affinity */}
          <div className="full-width">
            <label>
              How would you rate the affinity of your team towards technology
              versus people?
            </label>
            <select
              value={teamAffinity}
              onChange={(e) => setTeamAffinity(e.target.value)}
              required
            >
              <option value="">Select one</option>
              <option value="Predominantly Human-Centred">
                Predominantly Human-Centred
              </option>
              <option value="Somewhat Human-Centred">
                Somewhat Human-Centred
              </option>
              <option value="Somewhat Technology-Centric">
                Somewhat Technology-Centric
              </option>
              <option value="Predominantly Technology Centric">
                Predominantly Technology Centric
              </option>
            </select>
          </div>

          <div>
            <button type="submit">Sign Up</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;
